import React from 'react'
import '../assets/css/Sidebar.css'
//router
import {Link} from 'react-router-dom'
//img
import sidebar from '../assets/img/Sidebar__dashboard.svg';
import evetns from '../assets/img/Sidebar__events.svg';
import apikey from '../assets/img/Sidebar__apikey.svg';
import cocorobo from '../store/cocorobo';

class Sidebar extends React.Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    document.getElementById(`ListItem__${this.props.active}`).className = 'Sidebar__listItem Sidebar__listItem--active';
  }
  componentDidUpdate(){
    document.querySelectorAll('.Sidebar__listItem--active')[0].className='Sidebar__listItem';
    document.getElementById(`ListItem__${this.props.active}`).className = 'Sidebar__listItem Sidebar__listItem--active';
  }
  render () {
    const {logo , name} = this.props;
    var date = new Date();
    var year = date.getFullYear();
    return(
      <div className="Sidebar">
        <div className="Sidebar__header">
          <img src={logo} width='100%' height='100%' alt='Sidebar__headerLogo'/>
          <h2>{name}</h2>
        </div>
        <div className='Sidebar__list' onClick={this.toggleListItem}>
          <ul>
            <Link to='./events'>
              <li className='Sidebar__listItem' id='ListItem__events'>
              <img src={evetns} width='100%' height='100%' alt='Sidebar__events'/>
              <span>事件</span>
              </li>
            </Link>
            <Link to='./dashboard'>
              <li className='Sidebar__listItem' id='ListItem__dashboard'>
                <img src={sidebar} width='100%' height='100%' alt='Sidebar__dashboardLogo'/>
                <span>儀表板</span>
              </li>
            </Link>
            {/*<Link to='./apikey'>
              <li className='Sidebar__listItem' id='ListItem__apikey'>
                <img src={apikey} width='100%' height='100%' alt='Sidebar__apikey'/>
                <span>API Key</span>
              </li>
            </Link>*/}
          </ul>
        </div>
        <div className='Sidebar__version' >
          <p>
            <span>v1.2</span>
            <span style={{margin:'0 5px'}}></span>
            <span>
              <a href='http://help.cocorobo.hk/#/cocomod/coco-cloud' style={{color:'#fff'}}>
                幫助手冊
              </a>
            </span>
          </p>
        </div>
        <div className='Sidebar__LTD'>
          <p>CocoRobo LTD © {year} Copyright</p>
        </div>
      </div>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js